import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import styles from './AreaImageForm.styles';

import { LOCATION_TYPES } from '../../../../constants/areas';
import {
  drawPolygon,
  fitPolygon,
  getPolygonCenter
} from '../../../../utils/mapgl';
import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import Image from '../../../common/image/Image';
import MapGL from '../../../data/mapgl/MapGL';

export class AreaImageForm extends Component {
  onLoad = map => {
    let { polygon } = this.props;
    if (polygon) {
      drawPolygon(map, polygon, 'area-polygon', true);
      fitPolygon(map, polygon);
    }
  };
  render() {
    let center = this.props.polygon && getPolygonCenter(this.props.polygon);
    return (
      <AddForm onSubmit={this.props.handleSubmit} styles={styles.form}>
        {!this.props.isOutdoor &&
          this.props.files &&
          !!this.props.files.length && (
            <Image src={this.props.files[0].preview} alt="preview" />
          )}
        {this.props.isOutdoor && (
          <MapGL
            styles={styles.map}
            onLoad={this.onLoad}
            options={{
              center
            }}
          />
        )}
        <FormActions>
          {!this.props.isOutdoor && (
            <Button type="button" onClick={this.props.handleBack}>
              {I18n.t('add.back')}
            </Button>
          )}
          <Button>{I18n.t('add.add')}</Button>
        </FormActions>
      </AddForm>
    );
  }
}

const selector = formValueSelector('addarea');
const mapStateToProps = state => {
  const { file, location, polygon } = selector(
    state,
    'file',
    'location',
    'polygon'
  );
  return {
    files: file,
    isOutdoor: LOCATION_TYPES.OUTDOOR === location,
    polygon
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addarea',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(AreaImageForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/addareaform/areaimageform/AreaImageForm.js